import { BACKEND_URL } from "..";
import { PaginationResponse, SiteType, TeamContext } from "../../types/common";
import { FeatureNewsDto, NewsCategoryDto, NewsDto, SmiNewsLinkDto } from "../../types/news";

export const getFeaturedNews = async (teamContext: TeamContext = TeamContext.RODINA): Promise<FeatureNewsDto[]> => {
    const response = await fetch(`${BACKEND_URL}/news/featured/list-by-team/${teamContext}`);
    const data = await response.json();
    return data;
}

export const getSmiNewsLinks = async (): Promise<SmiNewsLinkDto[]> => {
    const response = await fetch(`${BACKEND_URL}/news/smi/list`);
    const data = await response.json();
    return data;
}

export const getNews = async (page: number, pageSize: number = 9, siteType: SiteType = SiteType.LEGACY_RODINA, filter: Partial<NewsDto> = null, excludeFilter: Partial<NewsDto> = null): Promise<PaginationResponse<NewsDto>> => {
    const filterParam = filter ? JSON.stringify(filter) : '';
    const response = await fetch(`${BACKEND_URL}/news?page=${page}&pageSize=${pageSize}&siteType=${siteType}&filter=${filterParam}&excludeFilter=${excludeFilter}`);
    const data = await response.json();
    return data;
}

export const getNewsCategories = async (siteType: SiteType = SiteType.LEGACY_RODINA): Promise<NewsCategoryDto[]> => {
    const response = await fetch(`${BACKEND_URL}/news/categories`);
    const data = await response.json();
    return data;
}

export const getNewsItem = async (newsId: number, siteType: SiteType = SiteType.LEGACY_RODINA): Promise<NewsDto> => {
    const response = await fetch(`${BACKEND_URL}/news/item/${newsId}?siteType=${siteType}`);
    const data = await response.json();
    return data;
}

export const getNewsItemByName = async (name: string, siteType: SiteType = SiteType.LEGACY_RODINA): Promise<NewsDto> => {
    const response = await fetch(`${BACKEND_URL}/news/item-by-name/${name}?siteType=${siteType}`);
    const data = await response.json();
    return data;
}